<template>
    <div>
        <div v-if="!aplicado">
            <div v-if="!idPago" class="text-right d-flex gap-2 flex-wrap justify-content-end">
                <div v-if="pagoPend > 0">
                    <button class="btn btn__buscar btn-sm" @click="continuePayment" :disabled="procesando">Continuar pago</button>
                </div>
                <div v-else>
                    <button class="btn btn__guardar btn-sm" @click="startPayment" :disabled="procesando">
                        <span v-if="procesando">Procesando...</span>
                        <span v-else>Pagar</span>
                    </button>
                </div>
            </div>
            <div v-else class="mt-2 pagoBtn">
                <div class="pagoMixto">
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <div class="form-group text-left">
                                <label class="mb-1 text-primary">Correo electrónico</label>
                                <input type="email" class="form-control" v-model="correoElectronico">
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group text-left">
                                <label class="mb-1 text-primary">Teléfono</label>
                                <input type="tel" class="form-control" v-model="telefono">
                            </div>
                        </div>
                        <div v-if="typepago === 'deducible' || typepago === 'recobro'" class="col-12 col-md-6">
                            <div class="form-group text-left">
                                <label class="mb-1 text-primary">Nit personalizado</label>
                                <input type="text" class="form-control" v-model="customNit" @change="validarNit">
                            </div>
                        </div>
                        <div v-if="typepago === 'recobro'" class="col-12 col-md-6">
                            <div class="form-group text-left">
                                <label class="mb-1 text-primary">Nombre</label>
                                <input type="text" class="form-control" v-model="customNombre">
                            </div>
                        </div>
                        <div class="col-12 col-md-6 pt-2">
                            <div class="form-group text-left">
                                <input id="actualizarDatos" type="checkbox" v-model="actualizarDatos">
                                <label for="actualizarDatos" class="mb-1 text-primary ml-2">Actualizar datos al aplicar</label>
                            </div>
                        </div>
                        <div v-if="(typepago === 'deducible' || typepago === 'recobro')" class="col-12 col-md-6 pt-2">
                            <div class="form-group text-left">
                                <input id="generarFac" type="checkbox" v-model="generarFactura" :readonly="(onlyfact !== 'none' && pagoL.length > 0)" :disabled="(onlyfact !== 'none' && pagoL.length > 0)">
                                <label for="generarFac" class="mb-1 text-primary ml-2">F</label>
                                <!--<select v-model="deducibleFactRec" class="form-control">
                                    <option value="R">Solo Recibo</option>
                                    <option value="F">Factura Y Recibo</option>
                                </select>-->
                            </div>
                        </div>
                        <div class="col-12 text-center mb-3 text-muted" v-if="onlyfact !== 'none' && pagoL.length > 0">
                            No puede editar "F" debido a que existen pagos previos realizados
                        </div>
                    </div>
                    <span class="text-primary">Este transacción de pago puede realizarse con distintos métodos, no se aplicará en ACSEL hasta presionar el botón aplicar. Operación de pago: 00{{idPago}}</span>
                    <div class="mt-2">
                        <div class="miniInfo">
                            <span class="font-weight-bold">Pagado tarjeta:</span> {{item.moneda}} {{ Numbro((pagadoTarjeta) ? pagadoTarjeta : 0).format({ thousandSeparated: true, mantissa: 2 }) }}
                        </div>
                        <div class="miniInfo">
                            <span class="font-weight-bold">Pagado efectivo:</span> {{item.moneda}} {{ Numbro((pagadoEfectivo) ? pagadoEfectivo : 0).format({ thousandSeparated: true, mantissa: 2 }) }}
                        </div>
                        <div class="miniInfo">
                            <span class="font-weight-bold">Pagado cheque:</span> {{item.moneda}} {{ Numbro((pagadoCheque) ? pagadoCheque : 0).format({ thousandSeparated: true, mantissa: 2 }) }}
                        </div>
                        <div class="miniInfo text-success">
                            <span class="font-weight-bold">Total a pagar:</span> {{item.moneda}} {{ Numbro((pagadoTotal) ? pagadoTotal : 0).format({ thousandSeparated: true, mantissa: 2 }) }}
                        </div>
                        <div class="miniInfo text-danger">
                            <span class="font-weight-bold">Restante:</span> {{item.moneda}} {{ Numbro((pagadoRestante) ? pagadoRestante : 0).format({ thousandSeparated: true, mantissa: 2 }) }}
                        </div>
                        <hr>
                        <div class="text-center mb-3" v-if="parseFloat(pagadoRestante) > 0">
                            <div>
                                Realizar pago parcial con:
                            </div>
                            <div class="mt-2">
                                <button @click="showPago('tarjeta')" class="btn btn-sm btn-primary m-2 btn__go">Tarjeta</button>
                                <button v-if="typeof userInfo.perfil !== 'undefined' && userInfo.perfil !== 'AGENTE'" @click="showPago('efectivo')" class="btn btn-sm btn-primary m-2 btn__go">Efectivo</button>
                                <button v-if="typepago === 'prima' && (typeof userInfo.perfil !== 'undefined' && userInfo.perfil !== 'AGENTE')" @click="showPago('cheque')" class="btn btn-sm btn-primary m-2 btn__go">Cheque</button>
                                <button v-if="typepago === 'prima' && (typeof userInfo.perfil !== 'undefined')" @click="sendPayLink" class="btn btn-sm btn-primary m-2 btn__go">Link</button>
                            </div>
                        </div>
                        <div v-else class="text-center">
                            Ya no tiene monto restante a pagar, únicamente aplique el pago
                        </div>
                        <hr>
                        <div class="text-center">
                            <div class="mb-1 text-danger">
                                {{pagoResultError}}
                            </div>
                            <div v-if="customNombre !== '' || customNit !== ''" class="my-2">
                                El comprobante se imprimirá con los datos:
                                <div v-if="customNombre !== ''">-Nombre: "{{customNombre}}"</div>
                                <div v-if="customNit !== ''">-NIT: {{customNit}}</div>
                            </div>
                            <button v-if="!enviadoAplicar && parseFloat(item.monto) >= parseFloat(pagadoTotal)" @click="makePago" class="btn btn-success mx-1 mt-1" :disabled="procesando">
                                <span v-if="procesando">Aplicando...</span>
                                <span v-else>Aplicar</span>
                            </button>
                            <!--<button @click="cancelarPago" class="btn btn-dark mx-1 mt-1">Cancelar</button>-->
                            <div v-if="enviadoAplicar" class="mt-2 text-muted">
                                Se ha intentado aplicar el pago, presione el botón buscar para actualizar
                            </div>
                        </div>
                    </div>
                </div>
                <Pago v-if="typepago === 'prima' && tipoPago" :idpago="idPago" :monto="parseFloat(pagadoRestante).toFixed(2)" :moneda="item.moneda" :tipo="tipoPago" :nombre="item.asegurado" :nit="item.nit" :direccion="item.direccion" @cerrarPago="cerrarPago" @pagado="montoPagado" :factura-recibo="deducibleFactRec"></Pago>
                <Pago v-if="(typepago === 'deducible' || typepago === 'recobro') && tipoPago" :idpago="idPago" :monto="parseFloat(pagadoRestante).toFixed(2)" :moneda="item.moneda" :tipo="tipoPago" :nombre="(customNombre !== '') ? customNombre : item.prNomcli" :nit="(customNit !== '') ? customNit : item.prNitcli" direccion="" @cerrarPago="cerrarPago" @pagado="montoPagado" bloquearmonto="true" :factura-recibo="deducibleFactRec"></Pago>
            </div>
        </div>
        <div v-else>
            <div class="text-center">
                <h6 class="text-primary">
                    {{aplicadoMsg}}
                </h6>
            </div>
            <div v-if="customNombre !== '' || customNit !== ''" class="my-2">
                El comprobante se imprimirá con los datos:
                <div v-if="customNombre !== ''">-Nombre: "{{customNombre}}"</div>
                <div v-if="customNit !== ''">-NIT: {{customNit}}</div>
            </div>
            <div v-if="telefono !== ''" class="my-2">
                Los datos de contacto utilizados son: "{{telefono}}" <span v-if="correoElectronico !== ''">y {{correoElectronico}}</span>
            </div>
            <div>
                <div v-if="isOnApp" @click="printInvoice" class="btn btn__imprimir mt-3 w-100">
                    Imprimir factura(s) y/o recibo
                </div>
                <div v-if="!isOnApp && imprimirFacturaUno" @click="printInvoicePdf" class="btn btn__imprimir mt-3 w-100">
                    Imprimir factura PDF
                </div>
                <div v-if="!isOnApp && imprimirFacturaDos" @click="printInvoicePdf" class="btn btn__imprimir mt-3 w-100">
                    Imprimir factura deducible PDF
                </div>
                <div v-if="!isOnApp && imprimirRecibo" @click="printReciboPdf" class="btn btn__imprimir mt-3 w-100">
                    Imprimir recibo PDF
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import API from "src/core/Api";
import Tools from "src/core/Tools";
import Numbro from "numbro";
import dayjs from "dayjs";
import {store} from "src/store";
import AndroidBridge from "src/core/AndroidBridge";
import Pago from "src/modules/pos/views/Pago";
import {CONFIG} from "src/config";
import {mapGetters} from "vuex";

export default {
    props: ['typepago', 'item', 'pagandoref', 'bloqueoaplicar', 'pagoLog', 'pagoPendiente', 'onlyfact'],
    components: {
        //TimelineChart,
        //Toster,
        Pago
    },
    data() {
        return {
            isOnApp: false,
            pagoPend: false,
            pagoL: {},
            idPago: false,
            tipoPago: false,
            aplicado: false,
            enviadoAplicar: false,
            aplicadoMsg: "",
            pagoResultError: "",
            generarFactura: false,
            deducibleFactRec: "R",
            actualizarDatos: false,

            //datos de persona
            correoElectronico: '',
            telefono: '',
            customNit: '',
            customNombre: '',

            // pagos mixtos
            pagadoTarjeta: 0,
            pagadoEfectivo: 0,
            pagadoCheque: 0,
            pagadoTotal: 0,
            pagadoRestante: 0,

            // despues de aplicacion
            infoFactura: {},
            infoFactura2: {},
            infoRecibo: {},

            // PARA VER QUE SE IMPRIME
            imprimirFacturaUno: false,
            imprimirFacturaDos: false,
            imprimirRecibo: false,

            userInfo: {},
            procesando: false,
        };
    },
    computed: {
    },
    watch: {
        // whenever question changes, this function will run
        generarFactura: function (newQuestion) {
            if (newQuestion) {
                this.deducibleFactRec = 'F';
            }
            else {
                this.deducibleFactRec = 'R';
            }
        },
        // whenever question changes, this function will run
        deducibleFactRec: function (newQuestion) {

            if (this.typepago === 'deducible') {
                if (newQuestion === 'R') {
                    this.item.monto = this.item.prVltded;
                    this.pagadoRestante = parseFloat(this.item.monto);
                }
                else {
                    this.item.monto = this.item.prVltdei;
                    this.pagadoRestante = parseFloat(this.item.monto);
                }

                if (parseFloat(this.item.prVltdep) > 0) {
                    this.item.monto = parseFloat(this.item.monto) + parseFloat(this.item.prVltdep);
                    this.pagadoRestante = this.item.monto;
                }
            }
            else if (this.typepago === 'recobro') {
                //console.log(this.item);
                if (newQuestion === 'R') {
                    this.item.monto = this.item.montoSiva;
                    this.pagadoRestante = parseFloat(this.item.montoSiva);
                }
                else {
                    this.item.monto = this.item.montoCIva;
                    this.pagadoRestante = parseFloat(this.item.monto);
                }
            }
        },
    },
    mounted() {
        const self = this;

        this.androidBridge = new AndroidBridge();
        this.isOnApp = this.androidBridge.appEnabled();
        this.pagoPend = parseInt(this.pagoPendiente);
        this.pagoL = this.pagoLog;
        this.userInfo = this.AuthGetUserInfo();

        this.generarFactura = !!(parseInt(this.onlyfact));

        if (this.typepago === 'deducible') {
            this.item.monto = this.item.prVltded;

            if (parseFloat(this.item.prVltdep) > 0) {
                this.item.monto = parseFloat(this.item.monto) + parseFloat(this.item.prVltdep);
            }
        }
        else if (this.typepago === 'recobro') {
            this.item.monto = parseFloat(this.item.montoSiva);
        }

        this.pagadoRestante = parseFloat(this.item.monto);
    },
    methods: {
        Numbro,
        dayjs,
        ...mapGetters(["AuthGetUserInfo"]),
        startPayment() {
            const self = this;

            if (self.procesando) {
                return;
            }

            if (confirm('Se iniciará una operación de pago, no debe pagar otros requerimientos hasta finalizar esta operación')) {
            /*if (true) {*/

                self.procesando = true;

                API.send('POST', 'cobros/iniciar-pago', {
                        tipo: self.typepago,
                        monto: self.item.monto,
                        requerimiento: self.item.requerimiento,
                        poliza: (self.typepago === 'deducible') ? self.item.prPoliza : self.item.poliza,
                        reclamo: self.item.reclamo,
                        reclamoRamo: self.item.ramo,
                        nombreAsegurado: self.item.asegurado,
                        nit: self.item.nit,
                        direccion: self.item.direccion,
                        acselItem: self.item,
                        recobro: self.item.recobro,
                        recobroNoPago: self.item.noPago,
                    },
                    function (response) {
                        if (response.status) {
                            self.idPago = response.data
                            //self.$emit('pagandoReferencia', self.item.requerimiento);
                        }
                        else {
                            alert(response.msg);
                        }
                        self.procesando = false;
                    },
                    function () {
                        self.procesando = false;
                        alert('Error de conexión, por favor intente de nuevo');
                    });
            }
        },
        continuePayment() {
            const self = this;

            self.idPago = self.pagoPend;

            for (let item in self.pagoL) {
                let type = '';

                if (self.pagoL[item].t === 'EFE') {
                    type = 'efectivo'
                }
                else if (self.pagoL[item].t === 'CHQ') {
                    type = 'efectivo'
                }
                else if (self.pagoL[item].t === 'TAR') {
                    type = 'tarjeta'
                }

                self.montoPagado({
                    tipo: type,
                    monto: self.pagoL[item].m,
                });
            }
        },
        validarNit() {
            const self = this;

            if (self.customNit !== '') {
                API.send('GET', 'validar/nit?s=' + self.customNit, false,
                    function (response) {
                        if (response.status) {
                            if (response.data !== '') {
                                self.customNombre = response.data
                            }
                            //self.$emit('pagandoReferencia', self.item.requerimiento);
                        }
                        else {
                            alert(response.msg);
                        }
                        store.dispatch('coreHideLoading');
                    },
                    function () {
                        store.dispatch('coreHideLoading');
                        alert('Error de conexión, por favor intente de nuevo');
                    });
            }
        },
        showPago(tipoPago) {

            /*this.nit = requerimiento.nit;
            this.nombre = requerimiento.asegurado;
            this.direccion = requerimiento.direccion;
            this.pagar = requerimiento.requerimiento;
            this.poliza = requerimiento.poliza;
            */
            this.tipoPago = tipoPago;
        },
        sendPayLink() {
            const self = this;
            if (confirm('Se enviará un enlace de pago al teléfono ingresado')) {
                API.send('POST', 'cobros/sendlink', {
                        tel: self.telefono,
                        idPago: self.idPago,
                        correo: self.correoElectronico,
                    },
                    function (response) {
                        store.dispatch('coreHideLoading');

                        if (response.status) {
                            self.aplicado = 1;
                            self.aplicadoMsg = 'Espere a que el cliente realice su pago, ' + response.msg
                        }
                        else {
                            alert(response.msg);
                        }
                    },
                    function () {
                        store.dispatch('coreHideLoading');
                        alert('Error de conexión, por favor intente de nuevo');
                    });
            }
        },
        montoPagado(data) {

            const self = this;

            if (data.tipo === 'efectivo') {
                this.pagadoEfectivo = parseFloat(data.monto) + parseFloat(this.pagadoEfectivo);
            }

            if (data.tipo === 'cheque') {
                this.pagadoCheque = parseFloat(data.monto) + parseFloat(this.pagadoCheque);
            }

            if (data.tipo === 'tarjeta') {
                this.pagadoTarjeta = parseFloat(data.monto) + parseFloat(this.pagadoTarjeta);
            }

            this.pagadoTotal = (parseFloat(this.pagadoEfectivo) + parseFloat(this.pagadoTarjeta) + parseFloat(this.pagadoCheque));
            this.pagadoRestante = parseFloat(this.item.monto) - this.pagadoTotal;

            this.tipoPago = false;

            if (this.pagadoRestante === 0 && !this.pagoPend) {
                self.makePago();
            }
        },
        cancelarPago() {
            this.idPago = false;
            this.tipoPago = false;
            this.pagadoTarjeta = 0;
            this.pagadoCheque = 0;
            this.pagadoEfectivo = 0;
            this.pagadoTotal = 0;
            this.pagadoRestante = parseFloat(this.item.monto);
        },
        cerrarPago() {
            this.tipoPago = false;
            /*store.dispatch('coreShowLoading');
            location.reload();*/
        },
        makePago(data) {

            const self = this;
            self.pagoResultError = '';

            if (self.procesando) {
                return false;
            }

            if (Tools.isEmptyString(self.telefono)) {
                self.pagoResultError = 'El teléfono es requerido';
                return false;
            }

            if (typeof this.bloqueoaplicar !== 'undefined' && this.bloqueoaplicar) {
                self.enviadoAplicar = true;
            }

            self.procesando = true;

            API.send('POST', 'cobros/aplicar/pago', {
                    idPago: self.idPago,
                    correoElectronico: self.correoElectronico,
                    telefono: self.telefono,
                    customNit: self.customNit,
                    customNombre: self.customNombre,
                    deducibleFactRec: self.deducibleFactRec,
                    acselItem: self.item,
                    tipo: self.typepago,
                    actualizarDatos: self.actualizarDatos,
                },
                function (response) {

                    if (typeof response.status !== 'undefined') {
                        if (response.status) {

                            self.aplicado = 1;
                            self.aplicadoMsg = response.msg;

                            if (typeof response.data.recibo !== 'undefined') {
                                self.infoRecibo = JSON.stringify(response.data.recibo);
                                self.imprimirRecibo = true;
                            }
                            if (typeof response.data.factura !== 'undefined') {
                                self.infoFactura = JSON.stringify(response.data.factura);
                                self.imprimirFacturaUno = true;
                            }
                            if (typeof response.data.factura2 !== 'undefined') {
                                self.infoFactura2 = JSON.stringify(response.data.factura2);
                                self.imprimirFacturaDos = true;
                            }

                            if (self.isOnApp && self.imprimirRecibo) self.androidBridge.PrintRecibo(self.infoRecibo);

                            setTimeout(function () {
                                if (self.isOnApp && self.imprimirFacturaUno) self.androidBridge.PrintFactura(self.infoFactura);

                                setTimeout(function () {
                                    if (self.isOnApp && self.imprimirFacturaDos) self.androidBridge.PrintFactura(self.infoFactura2);
                                }, 500);
                            }, 300);

                           /* self.pagoCompletado = true;
                            self.pagoResult = response.msg;
                            self.pagoCompletadoData = response.data;
                            self.idLog = (typeof response.data.idLog !== 'undefined') ? response.data.idLog : 0;*/


                            /*self.pagoCompletado = true;
                            self.pagoResult = response.msg;
                            self.pagoCompletadoData = response.data;
                            self.idLog = (typeof response.data.idLog !== 'undefined') ? response.data.idLog : 0;

                            if (response.data.voucher !== '') {
                                self.infoVoucher = JSON.stringify(response.data.voucher);
                            }
                            */
                            /*
                            */
                            /*if (self.isOnApp && typeof response.data.factura !== 'undefined') {
                                self.androidBridge.PrintFactura(self.infoFactura);
                                //self.androidBridge.PrintVoucher(self.infoVoucher);
                            }*/

                            self.makingPago = false;
                        }
                        else {
                            self.pagoResultError = response.msg;
                            //self.cancelarPago();
                        }
                    }
                    else {
                        self.pagoResultError = "Error en aplicar pago, por favor intente de nuevo";
                        //self.cancelarPago();
                    }
                    self.procesando = false;
                },
                function (response) {
                    console.log(response);
                    self.makingPago = false;
                    self.procesando = false;
                    alert('Error de conexión, por favor intente de nuevo');
                });
        },
        printInvoicePdf() {
            const self =this;
            API.send('POST', 'print/factura/' + self.idPago, null,
                function (response) {
                    store.dispatch('coreHideLoading');

                    if (response.status) {
                        window.open(CONFIG.apiUrl+"/download/docs/" + response.data);
                    }
                    else {
                        alert(response.msg);
                    }
                },
                function () {
                    store.dispatch('coreHideLoading');
                    alert('Error de conexión, por favor intente de nuevo');
                });
            //this.androidBridge.PrintVoucher(this.infoVoucher);
        },
        printReciboPdf() {
            const self =this;
            API.send('POST', 'print/recibo/' + self.idPago, null,
                function (response) {
                    store.dispatch('coreHideLoading');

                    if (response.status) {
                        window.open(CONFIG.apiUrl+"/download/docs/" + response.data);
                    }
                    else {
                        alert(response.msg);
                    }
                },
                function () {
                    store.dispatch('coreHideLoading');
                    alert('Error de conexión, por favor intente de nuevo');
                });
            //this.androidBridge.PrintVoucher(this.infoVoucher);
        },
        printInvoice() {

            const self = this;
            if (self.isOnApp && self.imprimirFacturaUno) self.androidBridge.PrintFactura(self.infoFactura);
            if (self.isOnApp && self.imprimirFacturaDos) self.androidBridge.PrintFactura(self.infoFactura2);
            if (self.isOnApp && self.imprimirRecibo) self.androidBridge.PrintRecibo(self.infoRecibo);
            //this.androidBridge.PrintFactura(this.infoFactura);
        },
    },
};
</script>
